import React from 'react';
import { Input, Label } from 'reactstrap';
import { T } from '../traks';

const SubscriptionDurationSelector = (props) => {
    const setTranslateType = (type) => {
        const typeMap = {
            'Months': <T>Monthly</T>,
            'Years': <T>Annual</T>,
        };

        return typeMap[type] || type;
    }

    return (
        <div>
            <div className="mb-2"><b><T>Subscription type</T></b></div>
            {['Months', 'Years'].map((duration) => {
             return (
                <div key={`duration-${duration.toLowerCase()}`} className='radio-item pr-lg-3'>
                    <Input type="radio" className={props.className ? `${props.className}`  : "form-check-input"} id={`duration_${duration.toLowerCase()}`} name="subscription_duration" value={duration.toLowerCase()} checked={duration.toLowerCase() === props.duration} onChange={props.onChange ? props.onChange : null} /> 
                    <Label className="form-check-label" for={`duration_${duration.toLowerCase()}`}>
                        <span>{setTranslateType(duration)}</span>
                    </Label>
                </div>
            )})}
        </div>
    )
}

export default SubscriptionDurationSelector;


// WEBPACK FOOTER //
// ./src/c/SubscriptionDuration.js